import theme from '../../theme';

export const getTheme = () => theme;

export default { getTheme };
